'use client';

import { cn } from '../../utils/cn';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'destructive';
}

export function Alert({ 
  children, 
  className, 
  variant = 'default',
  ...props 
}: AlertProps) {
  return (
    <div
      className={cn(
        'relative w-full rounded-lg border p-4',
        variant === 'destructive' 
          ? 'border-red-200 bg-red-50 text-red-900' 
          : 'border-zinc-200 bg-zinc-50 text-zinc-900',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

interface AlertDescriptionProps extends React.HTMLAttributes<HTMLParagraphElement> {}

export function AlertDescription({ 
  children, 
  className,
  ...props 
}: AlertDescriptionProps) {
  return (
    <p
      className={cn('text-sm', className)}
      {...props}
    >
      {children}
    </p>
  );
}
